import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/image/cta/CTA1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/image/cta/CTA2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/image/cta/CTA3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/image/cta/CTA4.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/image/cta/CTA5.webp");
;
import(/* webpackMode: "eager", webpackExports: ["MoreArticles"] */ "/vercel/path0/src/app/blog/_components/more-articles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/blog/_components/tag-item.tsx");
